var map = {
	"./search-results.de-CH.json": 984,
	"./search-results.de-DE.json": 985,
	"./search-results.en-CA.json": 986,
	"./search-results.en-GB.json": 987,
	"./search-results.en-IN.json": 988,
	"./search-results.en-ME.json": 989,
	"./search-results.en-US.json": 990,
	"./search-results.es-EM.json": 991,
	"./search-results.es-ES.json": 992,
	"./search-results.fr-BE.json": 993,
	"./search-results.fr-CA.json": 994,
	"./search-results.fr-CH.json": 995,
	"./search-results.nl-BE.json": 996,
	"./search-results.nl-NL.json": 997,
	"./search-results.pl-PL.json": 998,
	"./search-results.pt-BR.json": 999
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 983;